import { Link } from "react-router-dom";

const stats = [
  { value: "12,000+", label: "收录资讯" },
  { value: "3,600+", label: "作品条目" },
  { value: "870+", label: "深度解析" },
  { value: "24h", label: "资讯更新" },
];

export default function SiteIntro() {
  return (
    <section className="overflow-hidden rounded-lg border border-background-200 bg-primary-50">
      <div className="grid grid-cols-1 gap-8 p-6 md:p-10 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
            <i className="ri-planet-line" />
            关于星空动漫
          </span>
          <h2 className="mt-4 text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
            在星空下，陪你读懂每一部好作品
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
            星空动漫是一个专业的动漫内容门户。我们汇集最新资讯、筛选值得一看的作品，并用理性的视角拆解剧情与文化。无论你是刚入坑的新观众，还是关注行业多年的老友，都能在这里找到属于自己的那片星空。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            了解我们
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <p className="font-display text-2xl font-bold text-primary-600 md:text-3xl">
                {stat.value}
              </p>
              <p className="mt-1 text-sm text-foreground-600">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}